import React from 'react';
import styled from 'styled-components';
import { Link, useLocation } from 'react-router-dom';

const TitleStyle = styled.div`
    height: auto;
    padding: 10px;
    background: #0193de;
    margin-top: 45px;
    display: flex;
    flex-wrap: wrap; /* Allow titles to wrap into multiple rows */
    align-items: center;
    gap: 1vw;

    ${'' /* @media (max-width: 768px) {
        flex-direction: column;
        margin-top: 15px;
    } */}
`;


const TitleName = styled.div`
        height: 22px;
        padding: 6px 8px;
        background: ${({ isactive }) => isactive ? 'Yellow' : 'rgb(151, 231, 245)'};
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12.8px;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: 600;
        color: #000;
        cursor: pointer;
        border-radius: 3px;
        box-shadow: 0 7px 6px -3px rgb(0, 0, 0, 0.6);
    `;

const Titlebar = ({ data }) => {


    const { pathname } = useLocation();

    return (
        <>

            <div className="content">
                <TitleStyle>
                    {data.map((item, index) => (
                        <Link to={item.path} style={{ textDecoration: 'none' }} key={index}>
                            <TitleName isactive={item.path === pathname}>
                                {item.title}
                            </TitleName>
                        </Link>
                    ))}
                </TitleStyle>
            </div>
        </>

    );
}

export default Titlebar;
